import React from 'react';
import useStyle from './navBurgerList.style';
import { NavBurgerBlock } from 'components/molecules/Blocks/NavBurgerBlock';
import { loggedUserPages, profPages, settingPages } from 'routes/pages';
import { ButtonWithText } from 'components/atoms/Buttons/ButtonWithText';
import { getUserSidebar } from 'store/selectors/user/user.selectors';
import { AccountSidbarUser } from 'types/user/eleve.def';
import { useSelector } from 'react-redux';
import logout from 'graphql/logout';
import { BottomMenuLegend } from 'components/molecules/Blocks/BottomMenuLegend';
import { IS_PROF } from 'helpers/user/authorization';
import { BadgeAvatarSidebar } from 'components/molecules/Badges/BadgeAvatarSidebar';
import { createLinksBurgerMenu } from 'components/layouts/LoggedLayout/Menu/createLinks';

export const NavBurgerList = () => {
  const user: AccountSidbarUser = useSelector(getUserSidebar);
  const classes = useStyle();
  return (
    <div className={classes.root}>
      <div className={classes.container}>
        <div className={classes.menu}>
          <NavBurgerBlock withPadding={true}>
            <BadgeAvatarSidebar
              user={user}
              isMobile={true}
              goToDashboard={null}
            />
          </NavBurgerBlock>
          <NavBurgerBlock>
            <>
              {createLinksBurgerMenu(loggedUserPages)}
              {IS_PROF && createLinksBurgerMenu(profPages)}
            </>
          </NavBurgerBlock>
          <NavBurgerBlock>
            <>{createLinksBurgerMenu(settingPages)}</>
          </NavBurgerBlock>
          <NavBurgerBlock>
            <ButtonWithText
              variant="textDanger"
              content="Se déconnecter"
              onClick={logout}
            />
          </NavBurgerBlock>
        </div>
        <div className={classes.menuBottom}>
          <BottomMenuLegend
            items={[
              'Dashboard',
              'Reporting',
              'Pédagogie',
              'Quiz à faire',
              'Panier'
            ]}
          />
        </div>
      </div>
    </div>
  );
};
